module.exports = __webpack_public_path__ + "static/media/mouse.fbc4ac78.svg";